import { Injectable }                    from '@angular/core';
import { HttpHeaders, HttpClient }       from '@angular/common/http';
import { Router, ActivatedRoute }        from '@angular/router';

import { Observable, throwError }        from 'rxjs';
import { catchError, retry, map }        from 'rxjs/operators';

const httpOptions = {     
    headers: new HttpHeaders({        
        'Content-Type':  'application/json;charset=utf-8',    
    })    
};

@Injectable()
export class AuthenticationService {

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
    ){}

    login(rootUrl:string, username: string, passw: string):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/login', {username:username, password:passw}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

    authLogin(rootUrl:string, username: string, passw: string):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/login', {username:username, password:passw}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

    logout(rootUrl:string) {
        /*return this.http.post<any>(rootUrl+'assessor/logout', {}, httpOptions)
            .pipe()
            .subscribe(data => {
                if(data.code == 1000){
                    // remove user from local storage to log user out
                    localStorage.removeItem('currentUser');
                    this.router.navigateByUrl('/login');
                }
                else{
                    console.log(data);
                }
            },
            error => {
                console.log(error);
            });*/
        localStorage.removeItem('currentUser');
        this.router.navigateByUrl('/login');
    }

    resetPassword(rootUrl:string, username: string):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/forgot/password', {username:username}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
}